import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  LedgerRewards as LedgerRewardsComponent,
  LedgerRewardsProps,
} from "../../components/LedgerRewards/LedgerRewards";
import {
  getShopifyActiveDiscounts as getShopifyActiveDiscountsAction,
  getShopifyActiveGiftCards as getShopifyActiveGiftCardsAction,
} from "../../actions";
import { StoreState } from "../../reducers";
import {
  getRewardRequestStatus,
  getShopifyActiveDiscounts,
  getShopifyActiveGiftCards,
} from "../../reducers/methods";
import { customerAuthenticationOccurred } from "../../utils/customer";

interface LedgerRewardsContainerProps extends LedgerRewardsProps {
  getShopifyActiveDiscountsAction: typeof getShopifyActiveDiscountsAction;
  getShopifyActiveGiftCardsAction: typeof getShopifyActiveGiftCardsAction;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  shopifyActiveDiscounts: ReturnType<typeof getShopifyActiveDiscounts>;
  shopifyActiveGiftCards: ReturnType<typeof getShopifyActiveGiftCards>;
}

class LedgerRewards extends React.Component<LedgerRewardsContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.getRewards();
    }
  }

  componentDidUpdate(prevProps: LedgerRewardsContainerProps) {
    if (customerAuthenticationOccurred(prevProps.data, this.props.data)) {
      this.getRewards();
    }
  }

  getRewards = () => {
    const {
      rewardTypes,
      requestStatus,
      getShopifyActiveDiscountsAction,
      getShopifyActiveGiftCardsAction,
    } = this.props;

    if (
      rewardTypes.includes("shopifyDiscount") &&
      requestStatus.getShopifyActiveDiscounts !== "REQUESTING"
    ) {
      getShopifyActiveDiscountsAction();
    }

    if (
      rewardTypes.includes("shopifyGiftCard") &&
      requestStatus.getShopifyActiveGiftCards !== "REQUESTING"
    ) {
      getShopifyActiveGiftCardsAction();
    }
  };

  render() {
    return <LedgerRewardsComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  requestStatus: getRewardRequestStatus(state),
  shopifyActiveDiscounts: getShopifyActiveDiscounts(state),
  shopifyActiveGiftCards: getShopifyActiveGiftCards(state),
});

export default connect(mapStateToProp, {
  getShopifyActiveDiscountsAction,
  getShopifyActiveGiftCardsAction,
})(LedgerRewards);
